import React, { useState } from "react";
import ModalInterface from "../../Modal/Modal";
import DocumentUpload from "../../DocumentUpload/UI/DocumentUpload";
import Searcher from "../../Projects/UI/Searcher";
// import { postDocumentByProjectService } from "../Infrastructure/Documents.service";
import { AddIcon, CustomTextArea } from "../../Utils/UI/Text";
import { Select } from "antd";
import "./Documents.css";
import { CheckOutlined ,CloseOutlined } from "@ant-design/icons";

const DOC_TYPES = [
  { label: "profile_picture", value: "profile_picture" },
  { label: "company_id", value: "company_id" },
  { label: "local_tax_authority", value: "local_tax_authority" },
  { label: "registration", value: "registration" },
  { label: "legal_representation", value: "legal_representation" },
  { label: "last_statement", value: "last_statement" },
  { label: "personal_id", value: "personal_id" },
  { label: "bank_account_details", value: "bank_account_details" },
];

const NewDocument = ({
  userId,
  User,
  role,
  description,
  handleDescriptionChange,
  handleImageUpdate,
  getByUser,
}) => {
  const [docType, setDocType] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const desc = (description ?? "").trim();
  const tooShort = desc.length < 15;
  const disabled = !docType || tooShort;

  const handleProjectSelect = (projectId) => {
    console.log("Proyecto seleccionado en handleProjectSelect:", projectId);
    console.log("Tipo de dato:", typeof projectId);
    setSelectedProjectId(projectId);
  };

  return (
    <ModalInterface
      title="Nuevo Documento"
      text=""
      icon={
        role === User.CARBON_MANAGEMENT ? null : (
          <AddIcon
            onClick={() => getByUser(userId)}
            titleAdd="Agregar nuevo Documento"
          />
        )
      }
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
    >
      <Searcher onProjectSelect={handleProjectSelect} />
      <div className="container-document-file">
        <div className="container-document-file-item">
          <label className="ui-label">Tipo de documento</label>
          <Select
            placeholder="Selecciona el tipo de documento"
            options={DOC_TYPES}
            value={docType}
            onChange={setDocType}
            style={{ width: "100%" }}
            allowClear
          />
        </div>

        <div className="container-document-file-item">
          <div className="description-wrapper">
            <CustomTextArea
              label="Descripción"
              tooltipText="Escribe una breve descripción del documento"
              value={description || ""}
              onChange={handleDescriptionChange}
              placeholder="Escribe una descripción"
              maxLength={50}
              rows={4}
              allowClear
              showCount
            />

            {desc.length > 0 && (
              <div className="description-helper">
                <span
                  className={tooShort ? "description-error" : "description-ok"}
                >
                  {desc.length} / 15 {tooShort ? <CloseOutlined /> : <CheckOutlined />}
                </span>

                {tooShort && (
                  <div className="description-message">
                    La descripción debe tener al menos 15 caracteres para poder
                    subir la imagen.
                  </div>
                )}
              </div>
            )}
            <DocumentUpload
              type={docType}
              id={selectedProjectId}
              buttonText="Seleccionar Archivo"
              disabled={disabled}
              description={description}
              updateImage={async (...args) => {
                await handleImageUpdate(...args);
                setDocType(null);
              }}
            />
          </div>
        </div>
      </div>
    </ModalInterface>
  );
};

export default NewDocument;
